<div class="center">
  <div class="contact-div">Contact Me!</div>
  <a class="contact twitter" href="https://twitter.com/JohnAllis0n">Twitter</a>
  <a class="contact email" href="mailto:john@jallison.co.uk">Email</a>
  <a class="contact github" href="https://github.com/DannyDorito">Github</a>
  <a class="contact instagram" href="https://www.instagram.com/johnallis0n">Instagram</a>
  <a class="contact resume"
    href="https://docs.google.com/document/d/1zsnem12ZA2wqAPCwe3Y6CJdBgpnC0SpeCacsQYMILMQ/edit?usp=sharing">Resume</a>
  <!-- <a class="contact youtube" href="https://www.youtube.com/channel/UCo-lbwUsZgmX0tVH7gixR1g">YouTube</a> -->
  <a class="contact linkedin" href="https://www.linkedin.com/in/johnallison-">LinkedIn</a>
  <a class="contact steam" href="https://steamcommunity.com/id/Danny_Dorito">Steam</a>
  <a class="contact switch" href="https://i.imgur.com/7v9Q0lI.png">Nintendo Switch</a>
</div>
